export default "__VITE_ASSET__D0fXi70g__"